<template>
  <div class="top flex-column">
    <img src="@/static/images/round.png" />
    <div class="info flex-column">
      <!-- 广告图(主图) -->
      <div class="adv" :style="{ height: advs.banner.length > 0 ? 'auto': '92px' }">
        <MySwiper :swipers="advs.banner" radius="5px" :dotShow="false" />
      </div>
      <!-- 生活缴费/批量充值 -->
      <div class="list flex-row">
        <div v-if="advs.life[0]" class="item" @click="link(advs.life[0].url)">
          <img :src="advs.life[0].pic" />
        </div>
        <div v-if="advs.batch[0]" class="item" @click="link(advs.batch[0].url)">
          <img :src="advs.batch[0].pic" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import MySwiper from '@/components/swiper.vue'

  export default {
    components: {
      MySwiper
    },
    props: {
      advs: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {

      }
    },
    methods: {
      link(url) {
        const authToken = localStorage.getItem('auth_token')
        if (!authToken) {
          this.$message({
            message: "请先登录！",
            type: "warning"
          })
          return
        }
        if (!url) return
        this.$router.push(url)
      }
    }
  }
</script>

<style lang="less" scoped>
  .top {
    position: relative;
    text-align: left;
    .info {
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      padding: 0 4px;
      z-index: 9;
      .adv {
        // height: 92px;
        border-radius: 5px;
        background: #fff;
        // margin-top: 20px;
        margin-top: 27px;
      }
      .list {
        margin-top: 6px;
        .item {
          width: calc((100% - 4px) / 2);
          height: 42px;
          margin-right: 4px;
          background: #fff;
          border-radius: 5px;
          box-shadow: 2px 4px 8px -1px rgba(0, 0, 0, 0.15);
          overflow: hidden;
          &:nth-child(2n) {
            margin-right: 0;
          }
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/components/home/top.vue